[].slice.call(document.querySelectorAll('.titles-container button')).forEach(function(button, index) {
	button.addEventListener('click', function() {
		var titlesContainer = this.parentNode.parentNode,
			open = titlesContainer.querySelector('.open');

		if(this != open) {
			var servicesContainer = titlesContainer.parentNode.querySelector('.services-container'),
				openServiceButton = servicesContainer.querySelector('button.open'),
				currentServiceButton = servicesContainer.querySelector('li:nth-child('+(index+1)+') button');

			open.classList.remove('open');
			open.setAttribute('aria-selected', 'false');
			openServiceButton.classList.remove('open');
			openServiceButton.nextSibling.setAttribute('aria-expanded', 'false');
			openServiceButton.nextSibling.style = '';

			this.classList.add('open');
			this.setAttribute('aria-selected', 'true');
			currentServiceButton.classList.add('open');
			currentServiceButton.nextSibling.setAttribute('aria-expanded', 'true');
			currentServiceButton.nextSibling.style = '';
		}
	});
});

window.servicesAccordion = function servicesAccordion(servicesContainer, index) {
	if(checkWidth(1024)) {
		var titlesContainer = servicesContainer.parentNode.querySelector('.titles-container'),
			openTitlesButton = titlesContainer.querySelector('button.open'),
			currentTitlesButton = titlesContainer.querySelector('li:nth-child('+(index+1)+') button');

		openTitlesButton.classList.remove('open');
		openTitlesButton.setAttribute('aria-expanded', 'false');

		currentTitlesButton.classList.add('open');
		currentTitlesButton.setAttribute('aria-expanded', 'true');
	}
}